import { Layout } from '@/utils/routerHelper'

const myProfileRouter = {
  path: '/my-profile',
  component: Layout, 
  name: 'M_REFEREE_PROFILE',
  redirect: '/my-profile/index',
  meta: {
    // title: '个人信息',
    // icon: 'clarity:user-line'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/my-profile/index.vue'),
      name: 'M_REFEREE_PROFILE_VIEW',
      meta: {
        title: '我的信息',
        icon:  'clarity:user-line',
      },
    }
  ]
}

export default myProfileRouter
